import { ChevronUp, Trash2, MessageSquareReply } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Pill, fmtDate } from "@/components/hub/Common";

export const SuggestionCard = ({ s, onVote, onDelete, canVote, children }) => {
  const { t } = useI18n();
  return (
    <article data-testid={`suggestion-${s.id}`} className="cx-card cx-card-hover rounded-2xl p-5 flex gap-4 sm:gap-5">
      <button data-testid={`suggestion-vote-${s.id}`} disabled={!canVote} onClick={() => onVote?.(s)}
        className={`shrink-0 w-14 sm:w-16 h-16 sm:h-[72px] rounded-xl border flex flex-col items-center justify-center transition-colors duration-200 disabled:opacity-60 ${
          s.voted ? "border-[#3ad7ff] bg-[#3ad7ff]/15 text-[#3ad7ff] shadow-[0_0_24px_-8px_#3ad7ff]" : "border-white/10 text-slate-400 hover:border-[#2f7bff]/60 hover:text-white"}`}>
        <ChevronUp className="w-5 h-5" />
        <span className="font-display font-bold text-lg leading-none" data-testid={`suggestion-votes-${s.id}`}>{s.votes}</span>
      </button>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <Pill tone={s.status} testid={`suggestion-status-${s.id}`}>{t(`sug.st_${s.status}`)}</Pill>
          <span className="text-[11px] font-mono uppercase tracking-wider text-slate-500 border border-white/10 rounded-full px-2.5 py-1">{t(`sug.cat_${s.category}`)}</span>
        </div>
        <h3 className="font-display text-lg text-white mt-2 break-words">{s.title}</h3>
        <p className="text-sm text-slate-400 mt-1 whitespace-pre-line break-words">{s.body}</p>
        {s.admin_reply && (
          <div className="mt-3 rounded-lg border border-[#a746ff]/30 bg-[#a746ff]/[0.07] px-4 py-3" data-testid={`suggestion-reply-${s.id}`}>
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-wider text-[#c79bff]"><MessageSquareReply className="w-3.5 h-3.5" />{t("sug.reply")}</div>
            <p className="text-sm text-slate-300 mt-1 whitespace-pre-line">{s.admin_reply}</p>
          </div>
        )}
        <div className="flex items-center gap-3 mt-3 text-xs text-slate-500">
          <span>{t("sug.by")} <b className="text-slate-300">{s.author}</b> · {fmtDate(s.created_at)}</span>
          {onDelete && s.mine && (
            <button data-testid={`suggestion-delete-${s.id}`} onClick={() => onDelete(s)} className="ml-auto flex items-center gap-1 hover:text-rose-400 transition-colors"><Trash2 className="w-3.5 h-3.5" />{t("sug.delete")}</button>
          )}
        </div>
        {children}
      </div>
    </article>
  );
};
